import React, { useState, useEffect, useCallback } from "react";
import { useRouteMatch, Link } from "react-router-dom";
import { Button, FormGroup, Container, Row, Col } from "reactstrap";
import "./index.css";
import ScanningPeriodModal from "../components/ScanningPeriodModal";
import ScanningPeriod from "../components/ScanningPeriod";
import ApiCaller from "../../../api/apiCaller";

interface SiteTrafficCountingProps {
  siteIdInput?: number;
  viewOnly?: boolean;
}

export default function SiteTrafficCounting({
  siteIdInput,
  viewOnly,
}: SiteTrafficCountingProps) {
  const match = useRouteMatch("/sitev2/:site_id");
  const params: any = match?.params;
  const siteId = siteIdInput || params?.site_id;

  const [showScanningPeriodModal, setShowScanningPeriodModal] = useState<
    boolean
  >(false);
  const [scanningPeriods, setScanningPeriods] = useState<Array<any>>([]);

  const toogleScanningPeriodModal = () => {
    setShowScanningPeriodModal(!showScanningPeriodModal);
  };

  const getScanningPeriods = async () => {
    const res = await ApiCaller.get(
      `traffic_scan_period/?q=(filters:!((col:measure_for_content_type,opr:eq,value:site),(col:measure_for_content_id,opr:eq,value:${siteId})))`
    );
    if (res.result) {
      setScanningPeriods(res.result);
    }
  };

  useEffect(() => {
    getScanningPeriods();
  }, []);

  return (
    <Container>
      <Row>
        <Col xs={12}>
          <FormGroup>
            <Button color="primary" onClick={toogleScanningPeriodModal}>
              Tạo lượt đo mới
            </Button>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          {scanningPeriods.map((scanningPeriod) => (
            <ScanningPeriod
              key={scanningPeriod.id}
              scanningPeriod={scanningPeriod}
            />
          ))}
        </Col>
      </Row>
      {showScanningPeriodModal && (
        <ScanningPeriodModal
          isShow={showScanningPeriodModal}
          onSelectionModalClose={() => setShowScanningPeriodModal(false)}
          contentType="site"
          contentId={siteId}
          onItemSaved={() => getScanningPeriods()}
        />
      )}
    </Container>
  );
}
